<template>
  <div class="uploadWrapperOne">
    <el-upload class="uploadEl" name="attachment" :multiple="multiple" :action="fileUploadUrl" :headers="''|getHttpHeader" :before-upload="beforeUpload" :on-change="onChange" :on-progress="onProgress" :on-success="fileUploadSuccess" :accept="fileAccept" :file-list="fileList" :limit="limit" :on-remove="deleteAction">
      <i class="el-icon-upload" style="font-size:24px"></i>
      <div class="tip" v-if="tip">
        <span class="remmender">{{$t('portal.jin-zhi-chi-shang-chuan-1-ge-fu-jian')}}</span>
      </div>
    </el-upload>
  </div>
</template>

<script>
/**
 * 附件上传按钮组件
 * 能实现v-model双向数据绑定
 * 支持返回{ ipfs, file_name }和ipfs
 */

// 目前项目中使用到的只罗列这么多，待完善
const acceptObj = {
  csv: '.csv',
  xls: 'application/vnd.ms-excel application/x-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
};
export default {
  props: {
    // 编辑时对应ipfs或file
    value: {
      type: [String, Object]
    },
    // 接收类型，file|url|ipfs  默认返回{ ipfs, file_name }，或拼接好的url，否则仅为ipfs
    fileType: {
      type: String,
      default: 'file'
    },
    // 示例 csv/xls/xlsx/pdf
    accept: {
      type: String,
      default: ''
    },
    fileSize: {
      type: Number,
      default: 50000000
    },
    message: {
      type: String,
      default: 'portal.attachment_large'
    },
    theme: {
      type: String,
      default: ''
    },
    tip: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  computed: {
    fileAccept() {
      const {
        accept
      } = this;
      if (accept === '') {
        return '*.*';
      }
      return accept.split('/').map(fileExt => {
        return acceptObj[fileExt] || `.${fileExt}`;
      }).join(',');
    }
  },
  data() {
    return {
      fileUploadUrl: '/rest/erp/general/v3/upload',
      ipfsPrefix: '/rest/store/general/v3/image/',
      // 上传的文件大小
      uploadFileSize: 0,
      fileList: []
    };
  },
  methods: {
    onProgress(file) {
      this.$emit('onProgress', file);
    },
    onChange(file, fileList) {
      this.$emit('onChange', file, fileList);
    },
    fileUploadSuccess({
      data
    }, file, fileList) {
      if (this.multiple) {
        let newVal;
        newVal = JSON.stringify(fileList.map(item => ({
          size: item.size,
          ...item.response?.data
        })));
        this.$emit('input', newVal);
      } else {
        let newVal = data.ipfs;
        if (this.fileType === 'file') {
          newVal = data;
        } else if (this.fileType === 'url') {
          newVal = `${this.ipfsPrefix}${data.ipfs}`;
        }
        this.$emit('input', newVal);
        this.$emit('uploaded', {
          ...data,
          size: this.uploadFileSize
        });
      }
    },
    beforeUpload(file) {
      const {
        accept,
        fileSize
      } = this;
      const fileExt = file.name.split('.').length > 1 ? file.name.split('.').slice(-1)[0] : '';
      if (file.size > fileSize || accept !== '' && accept.indexOf(fileExt) < 0 || fileExt === '') {
        this.$message({
          message: this.$t(this.message),
          type: 'error'
        });
        return false;
      }
      // 暂存文件大小
      this.uploadFileSize = file.size;
      return true;
    },
    deleteAction(file, fileList) {
      if (this.multiple) {
        let newVal;
        newVal = JSON.stringify(fileList.map(item => item.response?.data));
        this.$emit('input', newVal);
      } else {
        this.$emit('input', '');
      }
      this.$emit('onRemove', file, fileList);
    }
  }
};
</script>

<style lang="less">
.uploadWrapperOne {
  height: 100%;
  .uploadEl {
    display: flex;
    align-items: center;
    height: 100%;
    .el-upload {
      display: flex;
      .tip {
        margin-left: 5px;
        color: #999;
      }
    }
    .el-upload-list {
      display: flex;
      flex-wrap: wrap;
      .el-upload-list__item {
        margin-top: 0;
        width: inherit;
      }
    }
  }
}
</style>
